import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import YouTubePlayer from 'youtube-player';

Snappy.Component.ResponsiveVideo = class ResponsiveVideo extends Snappy.BaseComponent {
    static get tagName() {
        return 'fa-responsive-video';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.init();
    }

    setVars() {
        this.player = null;
        this.thumbnailNode = this.$element.find('.js-rv-thumbnail');
        this.videoNode = this.$element.find('.js-rv-video');
        this.caption = this.$element.data('caption');
        this.isTracked = false;

    }

    setEventListeners() {
        $(document).on('responsiveVideo:stopVideo', this.onEventStopVideo.bind(this));
        this.thumbnailNode.on('click', this.onClickThumbnailHandler.bind(this));
    }

    init() {
        this.player = YouTubePlayer( this.videoNode[0], {
            videoId: this.videoNode.data('video-id'),
            playerVars: { rel : 0 }
        });

        this.player.on('ready', this.setEventListeners.bind(this));

        this.player.on('stateChange', this.onStateChange.bind(this) );
    }

    onStateChange( event ) {

        if ( event.data === YT.PlayerState.BUFFERING || event.data === YT.PlayerState.PLAYING ) {
            this.thumbnailNode.fadeOut(200);

            if (this.$body.hasClass('cfa-generic') && !this.isTracked) {
                this.$window.trigger('gtm:send', [ 'Video', 'Play', this.caption]);
                this.isTracked = true;
            }
        }
    }

    onEventStopVideo() {
        this.player.stopVideo();
        this.thumbnailNode.show();
    }

    //IE FIX; Doesn't support pointer-events property
    onClickThumbnailHandler(){
        this.thumbnailNode.fadeOut(200);
        this.player.playVideo();
    }
};



// WEBPACK FOOTER //
// ./components/responsive-video/scripts/responsive-video.js